//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import FactorUnitDrawer from "./modules/FactorUnitDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryProjectArchtList } from '@/api/api';
export default {
  name: 'FactorUnitList',
  mixins: [JeecgListMixin],
  components: {
    FactorUnitDrawer: FactorUnitDrawer
  },
  data: function data() {
    return {
      pagePath: '/site/factor/unit',
      pageTitle: '环境监测因子单位',
      // 表头
      columns: [// {
      //   title: '序号',
      //   dataIndex: '',
      //   key: 'rowIndex',
      //   width: 60,
      //   align: 'center',
      //   customRender: function(t, r, index) {
      //     return parseInt(index) + 1
      //   }
      // },
      {
        dataIndex: 'title',
        colName: 'title',
        title: '名称',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'alias',
        colName: 'alias',
        title: '英文名称',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'category_dictText',
        colName: 'category',
        title: '单位类型',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'stand_dictText',
        colName: 'stand',
        title: '是否标准单位',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'conver',
        colName: 'conver',
        title: '单位转换算法',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'status_dictText',
        colName: 'status',
        title: '状态',
        align: 'center',
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {},
  computed: {},
  methods: {}
};